<template>
  <div class="coupons-retrieved-list">
    <div class="bg-dark py-4 user-profile-form-heading">
      <div class="container">
        <div class="row">
          <div class="col-sm-9 d-flex align-items-center" v-if="user">

            <!--                  <img :src="user.cluster_image" :alt="user.cluster_name" class="cluster-image mr-4">-->
            <!--                  <h5 class="d-inline-block text-white">-->
            <!--                    Sei un cliente <strong class="text-accent" :style=" user.cluster_color ? 'color: ' + user.cluster_color + '!important;' : '' ">{{ user.cluster_name }}</strong><br>-->
            <!--                    <span class="mt-2">{{ user.loyalty_line }}</span>-->

            <!--                  </h5>-->
            <user-cluster :profile="true"></user-cluster>

          </div>
          <div class="col-sm-3 d-flex row" v-if="coupons.length > 0">
<!--            <div class="col-sm-12 d-flex align-items-center justify-content-start  justify-content-md-end">-->
<!--              <a @click='aaEvent("click", { form: { click: "PIN – Negozi TIM" } })' href="/pin-attivi" class="text-white ">{{ __('PIN – NEGOZI TIM') }}&nbsp;&rsaquo;</a>-->
<!--            </div>-->
            <div class="col-sm-12 d-flex align-items-center justify-content-start  justify-content-md-end">
              <a @click='aaEvent("click", { form: { click: "Vantaggi richiesti" } })' href="/vantaggi-richiesti" class="text-white ">{{ __('I VANTAGGI RICHIESTI') }}&nbsp;&rsaquo;</a>
            </div>
            <div class="col-sm-12 d-flex align-items-center justify-content-start  justify-content-md-end">
              <a @click='aaEvent("click", { form: { click: "Le tue vincite" } })' href="/le-tue-vincite" class="text-white ">{{ __('LE TUE VINCITE') }}&nbsp;&rsaquo;</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="coupons-container border-primary mt-1 border-top">
      <div class="container">
        <LoaderOverlay v-if="loading"/>
        <div class="coupons-retrieved-table" v-if="coupons.length > 0 && coupons[0] != 0">
          <div class="d-none d-sm-block py-5">
            <div class="row">
              <div class="col-sm-4 col-lg-9 heading text-muted">{{ __('Descrizione PIN') }}</div>
              <div class="col-sm-8 col-lg-3 heading text-muted">{{ __('PIN - NEGOZI TIM') }}</div>
            </div>
          </div>
          <div class="coupon-retrieved-item py-4" v-for="coupon in coupons" v-bind:key="coupon.contestCode">
            <div class="row">
              <div class="col-sm-4 col-lg-9 heading text-muted d-block d-sm-none order-sm-1">{{ __('Descrizione PIN') }}</div>
              <div class="col-sm-4 col-lg-9 order-1 order-sm-2">
                <h5 class="contest-name mb-2 mt-2 border" v-html="coupon.contestName"></h5>
              </div>
              <div class="col-sm-4 col-lg-9 heading text-muted d-block d-sm-none order-sm-3">{{ __('PIN - NEGOZI TIM') }}</div>
              <div class="col-sm-8x` col-lg-3 order-2 order-sm-4">
                <div>
                  <div class="coupon-code text-center border border-secondary"><h5 class="mb-2 mt-2">{{ coupon.code }}</h5></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="py-5" v-else-if="!loading">
          Nessun Codice PIN a disposizione.
        </div>



      </div>
    </div>
  </div>

</template>

<script>

/* eslint-disable */

import UserCluster   from "@/components/UserCluster";
import TimPartyMixin from '../mixins/TimPartyMixin';
import LoaderOverlay from './LoaderOverlay.vue'
import $             from 'jquery';
import moment        from 'moment';
import 'slick-carousel';


export default {
  name: 'ShopCouponsListRetrieved',
  mixins: [TimPartyMixin],
  components: {UserCluster, LoaderOverlay},
  props: {
    apiUrl: {
      type: String,
      default: '/api/catalog/handleAction',
    },
    catalogUrl: String,
  },
  data: function () {
    return {
      loading: false,
      coupons: [],
    };
  },
  mounted: function () {
    this.setApiUrl(this.apiUrl);

    this.getRetrievedCoupons();

  },
  methods: {
    getRetrievedCoupons: function() {
      var self = this;

      var payload = {
        action: 'getRetrievedShopCoupons',
        access_token: this.accessToken,
      };

      self.loading = true;
      this.callApi( payload, function(response) {
        var coupons = [];
        var row = {};
        for(var i in response){
          coupons.push(response[i]);
        }
        self.coupons = coupons;
        self.loading = false;
      });
    }
  },
  computed:{
  },
  watch: {
    access_token: function( new_val, old_val){
      this.getRetrievedCoupons();
    },
    current_timespan: function(new_val, old_val){
      this.current_page = 1;
    }
  }
}
</script>
